<template>
  <div v-loading="isLoading">
    <el-tabs v-model="tabPane">
      <el-tab-pane label="分數佔比設定" name="proportion">
        <el-table :data="tableData" stripe style="width: 80%">
          <el-table-column header-align="center" align="center" width="50">
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.isExam"
                v-if="scope.row.name == '筆試'"
                @change="isChecked"
              ></el-checkbox>
            </template>
          </el-table-column>

          <el-table-column
            prop="name"
            label="考試項目"
            header-align="center"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="proportion"
            label="分數佔比"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-col :span="18">
                <el-input-number
                  v-model="scope.row.proportion"
                  controls-position="right"
                  :controls="false"
                  :disabled="scope.row.name == '筆試' && !scope.row.isExam"
                  :min="0"
                  :max="100"
                ></el-input-number>
              </el-col>
              <span> %</span>
            </template>
          </el-table-column>
        </el-table>
        <br />
        <span style="color: #8f8f8f"
          >註：分數佔比設定 及 背書必考內容 需都填寫完成，才可完成儲存。
        </span>
      </el-tab-pane>

      <el-tab-pane label="背書必考內容" name="must">
        <div style="margin: 20px">
          <el-row>
            <div
              style="font-size: 20px; font-weight: bold; margin-bottom: 10px"
            >
              必考級別設定
            </div>
          </el-row>

          <el-row v-for="(item, index) in mustData" :key="index">
            <el-card>
              <el-row>
                <el-col :span="6">
                  <span style="font-size: 16px; font-weight: bold"
                    >級別{{ index + 1 }}</span
                  >
                  <br />
                  <br />
                  <span style="font-size: 16px; font-weight: bold"
                    >級別背誦範圍</span
                  >
                </el-col>
                <el-col :span="6" :offset="12">
                  <el-button
                    v-if="index + 1 == mustData.length && item.delete"
                    style="float: right; padding: 3px 0; margin-right: 10px"
                    type="text"
                    @click="deleteCard(index)"
                  >
                    <span class="f-btn"><i class="el-icon-delete"></i></span>
                  </el-button>
                </el-col>
              </el-row>
              <el-row style="margin: 10px">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="背誦內容"
                  v-model="item.itemRange"
                >
                </el-input>
              </el-row>
              <el-row style="line-height: 40px">
                <el-col :span="12">
                  <el-col :span="8">
                    <span
                      style="
                        font-size: 16px;
                        font-weight: bold;
                        float: right;
                        margin-right: 10px;
                      "
                      >考試字數</span
                    >
                  </el-col>
                  <el-col :span="10">
                    <el-input-number
                      v-model="item.count"
                      controls-position="right"
                      :controls="false"
                      :min="0"
                    ></el-input-number>
                  </el-col>
                  <span style="margin-left: 10px"> 字</span>
                </el-col>

                <el-col :span="12">
                  <el-col :span="8">
                    <span
                      style="
                        font-size: 16px;
                        font-weight: bold;
                        float: right;
                        margin-right: 10px;
                      "
                      >得分</span
                    >
                  </el-col>
                  <el-col :span="10">
                    <el-input-number
                      v-model.number="item.dfPoints"
                      controls-position="right"
                      :controls="false"
                      :min="0"
                    ></el-input-number>
                  </el-col>
                  <span style="margin-left: 10px"> 分</span>
                </el-col>
              </el-row>
            </el-card>
            <br />
          </el-row>
          <el-row type="flex">
            <el-button type="text" @click="addCard">
              <i class="el-icon-circle-plus-outline"></i>
              新增分格選項
            </el-button>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
    <br />
    <el-row type="flex" justify="center">
      <el-button @click="closeDialog">取消</el-button>
      <el-button id="test_lifeClass_btAddgo" @click="editSave" type="primary"
        >儲存</el-button
      >
    </el-row>
  </div>
</template>

<script>
import API from "@/api/";
import Utils from "@/utils";
import { InformType } from "@/utils/InformType";
export default {
  props: {
    clickTime: Date,
    id: { Number, default: NaN },
  },

  watch: {
    clickTime: function () {
      console.log("clickTime watch");
      console.log("id", this.id);
      this.query();
      this.tabPane = "proportion";
      this.deleteId = [];
    },
  },

  created: function () {
    this.query();
  },

  data() {
    return {
      isLoading: false,
      tabPane: "proportion",
      tableData: [],
      mustData: [],
      deleteId: [],
    };
  },
  methods: {
    query() {
      console.log("讀取");
      this.isLoading = true;
      API.studyYear.findSetUp(this.id).then((res) => {
        console.log(res.data);
        this.tableData = res.data.proportion;
        this.mustData = res.data.must;

        this.isLoading = false;
      });
    },
    isChecked(checked) {
      if (checked) {
        this.tableData[0].proportion = 10;
        this.tableData[1].proportion = 55;
        this.tableData[2].proportion = 35;
      } else {
        this.tableData[0].proportion = 0;
        this.tableData[1].proportion = 60;
        this.tableData[2].proportion = 40;
      }
    },
    inputBlur(row) {
      if (row.proportion == "") row.proportion = 0;
    },
    closeDialog() {
      this.$emit("close");
    },
    addCard() {
      let addnew = {
        id: 0,
        itemRange: "",
        count: 0,
        dfPoints: 0,
        seq: this.mustData.length,
        delete: true,
      };
      this.mustData.push(addnew);
    },
    deleteCard(idx) {
      if (this.mustData[idx].id != 0) this.deleteId.push(this.mustData[idx].id);
      this.mustData.splice(idx, 1);
    },
    editSave() {
      if (
        this.tableData[0].proportion +
          this.tableData[1].proportion +
          this.tableData[2].proportion !=
        100
      ) {
        Utils.Message.send("分數佔比設定非100%", InformType.WARNING);
        return;
      }
      console.log(this.mustData);

      let r = false;
      this.mustData.forEach((item, index) => {
        if (Utils.Check.isNull(item.itemRange)) {
          Utils.Message.send(
            `級別${index + 1}: 背誦範圍不能為空！`,
            InformType.WARNING
          );
          r = true;
        }
        if (item.count == 0) {
          Utils.Message.send(
            `級別${index + 1}: 字數不能為0`,
            InformType.WARNING
          );
          r = true;
        }
        if (item.dfPoints == 0) {
          Utils.Message.send(
            `級別${index + 1}: 分數不能為0`,
            InformType.WARNING
          );
          r = true;
        }
        if (item.count == undefined) {
          Utils.Message.send(
            `級別${index + 1}: 字數不能為空`,
            InformType.WARNING
          );
          r = true;
        }
        if (item.dfPoints == undefined) {
          Utils.Message.send(
            `級別${index + 1}: 分數不能為空`,
            InformType.WARNING
          );
          r = true;
        }
      });
      if (r) return;

      let from = {
        fpp: this.tableData,
        mustItem: this.mustData,
        deleteId: [{ id: this.deleteId }],
      };
      console.log("儲存", this.id, from);
      this.isLoading = true;
      API.studyYear
        .updateSetUp(this.id, from)
        .then(() => {
          Utils.Message.send("修改成功!", InformType.SUCCESS);
          this.isLoading = false;
          this.closeDialog();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="css">
.f-btn {
  color: red !important;
}

.el-input-number.is-without-controls .el-input__inner {
  width: 100px;
  line-height: 30px;
  height: 28px;
}
</style>